import React from 'react';
import { connect } from 'react-redux';

const AvailabilityAlert = props => (!props.quantity || props.quantity < 8) && (
  <div className="alert alert-warning">
    {props.properties.message}
  </div>
);

const mapStateToProps = ({ reservation: { offer } }) => ({
  quantity: (offer && offer.quantity) || (offer && offer.price && offer.price.quantity) || 0
});

export default connect(mapStateToProps)(AvailabilityAlert);
